import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import { orderDetailsActions } from '../../../../../../store/external/order/order-details.reducer';
import { SelectFieldFloatingLabel as Select } from '../../../../../common/custom-form/select-filter.component';
import { formValidationAction } from '../../../../../../store/common/form-validation/form-validation.reducer';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
class ContactInfomation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropDown: false            
        }
    }
    async componentDidMount() {
        const { orderDetailsForm } = this.props;

        await this.props.getUserContactEmail(1, orderDetailsForm.altContactEmail);
        await this.props.getTechnicalUserContactEmail(1, orderDetailsForm.techContactEmail);
    }
    handleToggle = () =>{
        this.setState(prev => ({isDropDown: !prev.isDropDown}))
    }
    onChangeContactUser = (propsName, value) => {
        this.props.FormChange(propsName, value)
        this.props.setContactEmail(propsName, value);
    }
    handleEmailValidation=()=>{
        const {emailValidation} = this.props;
        emailValidation();
    }
    isOrderStatusCompleted = () => {
        const { orderDetailsForm } = this.props;
        return orderDetailsForm?.orderStatus === "Completed";
    }

    handleUserEmailSearch = (searchString) => {
        this.props.getUserContactEmail(1, searchString)
    }

    loadMoreUserEmail = (searchString) => {
        const { userContactEmailPage } = this.props.orderDetails;

        this.props.getUserContactEmail(userContactEmailPage + 1, searchString)
    }

    handleTechnicalUserEmailSearch = (searchString) => {
        this.props.getTechnicalUserContactEmail(1, searchString)
    }

    loadMoreTechnicalUserEmail = (searchString) => {
        const { technicalUserContactEmailPage } = this.props.orderDetails;

        this.props.getTechnicalUserContactEmail(technicalUserContactEmailPage + 1, searchString)
    }
    render() {
        const { translator, orderDetails, orderDetailsForm, emailValidation } = this.props;
        const { isDropDown } = this.state;
        return (
            <div className="form_details_container control-container">
                <CustomDropdown activeDropdown={isDropDown} toggleActiveState={() => this.handleToggle()} label={translator("contact_information_details")} >
                <div className={`detail-page-container details-3-col-22-container`}>  
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("local_contact_email")}
                            placeholder={translator("enter_text_placeholder")}
                            value={orderDetailsForm.localContactEmail ?? ''}
                            fieldProp="orderDetailsForm.localContactEmail"
                            maxLength={MAX_LENGTH.limit_100}   
                            onBlurAction={emailValidation} 
                            disabled={this.isOrderStatusCompleted()}
                        />  

                         <InputField
                            className="form-control"
                            type="text"
                            label={translator("local_contact_fullname")}
                            placeholder={translator("enter_text_placeholder")}
                            value={orderDetailsForm.localContactFullName}
                            fieldProp='orderDetailsForm.localContactFullName'
                            maxLength={MAX_LENGTH.limit_100}        
                            disabled={this.isOrderStatusCompleted()}
                         />  

                         <InputField
                            className="form-control"
                            type="text"
                            label={translator("local_contact_phone_number")}
                            placeholder={translator("enter_text_placeholder")}
                            value={orderDetailsForm.localContactPhoneNumber}
                            fieldProp='orderDetailsForm.localContactPhoneNumber'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={this.isOrderStatusCompleted()}

                        />           
                        <CustomSearchableDropdownWrapper
                            label={translator("alt_contact_email_address")}
                            options={orderDetails.userContactEmailDropdown}
                            selected={orderDetailsForm.altContactId}
                            onChange={(e) => this.onChangeContactUser("orderDetailsForm.altContactId", e)}
                            placeholder={`${translator('select_placeholder')}`}
                            fieldProp='orderDetailsForm.altContactId'
                            tagName='.altContactId'
                            isNullable={true}
                            optionLabelKey={{
                                Key: 'UserId',
                                Value: 'Email'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={this.isOrderStatusCompleted()}

                            onSearchChange={this.handleUserEmailSearch}
                            onLoadMore={this.loadMoreUserEmail}
                            isLoading={orderDetails.isUserEmailLoading}
                            hasMore={orderDetails.hasMoreUserContactEmail}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("alt_contact_full_name")}
                            value={orderDetailsForm.altContactFullName}
                            fieldProp='orderDetailsForm.altContactFullName'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("alt_contact_phone_number")}
                            value={orderDetailsForm.altContactPhoneNumber}
                            fieldProp='orderDetailsForm.altContactPhoneNumber'
                            maxLength={MAX_LENGTH.limit_100}
                            placeholder={translator("enter_text_placeholder")}
                            disabled={this.isOrderStatusCompleted()}
                        />       
                        <CustomSearchableDropdownWrapper
                            label={translator("technical_contact_email_address")}
                            options={orderDetails.technicalUserContactEmailDropdown}
                            selected={orderDetailsForm.techContactId}
                            onChange={(e) => this.onChangeContactUser("orderDetailsForm.techContactId", e)}
                            placeholder={`${translator('select_placeholder')}`}
                            fieldProp='orderDetailsForm.techContactId'
                            isNullable={true}
                            tagName='.techContactId'
                            optionLabelKey={{
                                Key: 'UserId',
                                Value: 'Email'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={this.isOrderStatusCompleted()}

                            onSearchChange={this.handleTechnicalUserEmailSearch}
                            onLoadMore={this.loadMoreTechnicalUserEmail}
                            isLoading={orderDetails.isUserEmailLoading}
                            hasMore={orderDetails.hasMoreUserContactEmail}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("technical_contact_fullname")}
                            value={orderDetailsForm.techContactFullName}
                            fieldProp='orderDetailsForm.techContactId'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}
                        />
                        
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("technical_contact_phone_number")}
                            value={orderDetailsForm.techContactPhoneNumber}
                            fieldProp='orderDetailsForm.techContactPhoneNumber'
                            maxLength={MAX_LENGTH.limit_100}
                            placeholder={translator("enter_text_placeholder")}
                            disabled={this.isOrderStatusCompleted()}
                        />                     
                </div>
                </CustomDropdown>
                
            </div>
        );
    }
}


export default connect(
    state => {
        const { orderDetails, translation } = state;
        const { orderDetailsForm } = state.form;
        return {           
            ...translation,
            orderDetailsForm,
            orderDetails
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderDetailsActions, formValidationAction),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ContactInfomation);